module.exports = __webpack_public_path__ + "img/footer_party-th.140a3227.png";